<aside class="os-inst-panel" [class.os-inst-panel--empty]="!installation">
  @if (loading && !installation) {
  <div class="os-inst-empty os-inst-empty--loading">
    <i class="pi pi-spin pi-spinner"></i>
    <p>{{ 'service-order.installation-panel-loading' | translate }}</p>
  </div>
  } @else if (notFound) {
  <!-- OS aponta para uma referência que a consulta de instalação não devolve (apagada ou de outra empresa) -->
  <div class="os-inst-empty os-inst-empty--missing">
    <i class="pi pi-exclamation-triangle"></i>
    <p>{{ 'service-order.installation-panel-not-found' | translate: { reference: reference } }}</p>
  </div>
  } @else if (!installation) {
  <div class="os-inst-empty">
    <i class="pi pi-map-marker"></i>
    <p>{{ 'service-order.installation-panel-empty' | translate }}</p>
  </div>
  } @else {
  <div class="os-inst-title">
    <span class="os-inst-title-text">
      {{ 'service-order.installation-panel-title' | translate }} <b>{{ installation.reference || '—' }}</b>
    </span>
    @if (installation.details?.isActive !== null && installation.details?.isActive !== undefined) {
    <span class="os-inst-status" [class.os-inst-status--off]="!installation.details?.isActive"
      [title]="(installation.details?.isActive ? 'service-order.active-label' : 'service-order.inactive-label') | translate">
      <span class="os-inst-dot"></span>
      {{ (installation.details?.isActive ? 'service-order.active-label' : 'service-order.inactive-label') | translate }}
    </span>
    }
  </div>

  <!-- Plaqueta renomeada depois da OS: antes -> depois, sem frase -->
  @if (referenceChanged) {
  <div class="os-inst-renamed">
    <span class="os-inst-renamed-title">
      <i class="pi pi-info-circle"></i>
      {{ 'service-order.installation-reference-changed' | translate }}
    </span>
    <span class="os-inst-renamed-diff">
      <s class="os-inst-renamed-old">{{ reference }}</s>
      <i class="pi pi-arrow-right"></i>
      <b class="os-inst-renamed-new">{{ installation.reference }}</b>
    </span>
  </div>
  }

  <!-- Mapa só com a flag ligada; sem ela, coordenadas + link (custo zero) -->
  @if (staticMapUrl) {
  <a class="os-inst-map" [href]="mapsLink" target="_blank" rel="noopener">
    <img [src]="staticMapUrl" [alt]="'service-order.static-map-alt' | translate" loading="lazy" />
    <span class="os-inst-map-coords">{{ coordinates }}</span>
  </a>
  } @else {
  <div class="os-inst-kv">
    <span class="os-inst-k">{{ 'service-order.coordinates-label' | translate }}</span>
    @if (coordinates) {
    <span class="os-inst-v os-inst-v--mono">{{ coordinates }}</span>
    <a class="os-inst-link" [href]="mapsLink" target="_blank" rel="noopener">
      {{ 'service-order.open-in-maps' | translate }} <i class="pi pi-external-link"></i>
    </a>
    } @else {
    <span class="os-inst-v os-inst-v--empty">{{ 'service-order.not-informed' | translate }}</span>
    }
  </div>
  }

  <div class="os-inst-kv">
    <span class="os-inst-k">{{ 'service-order.address-label' | translate }}</span>
    @if (addressLine || localityLine) {
    @if (addressLine) { <span class="os-inst-v">{{ addressLine }}</span> }
    @if (localityLine) { <span class="os-inst-v os-inst-v--sub">{{ localityLine }}</span> }
    } @else {
    <span class="os-inst-v os-inst-v--empty">{{ 'service-order.not-informed' | translate }}</span>
    }
  </div>

  <div class="os-inst-kv">
    <span class="os-inst-k">{{ 'service-order.equipment-label' | translate }}</span>
    @if (hasDevice) {
    @if (installation.serialNumber) { <span class="os-inst-v os-inst-v--mono">{{ installation.serialNumber }}</span> }
    @if (installation.deviceMac) { <span class="os-inst-v os-inst-v--mono os-inst-v--sub">{{ installation.deviceMac }}</span> }
    @if (installation.details?.equipmentType) { <span class="os-inst-v os-inst-v--sub">{{ installation.details?.equipmentType }}</span> }
    } @else {
    <!-- OS para poste sem dispositivo é caso real (lote): o técnico precisa saber antes de sair -->
    <span class="os-inst-warning">
      <i class="pi pi-exclamation-triangle"></i>
      {{ 'service-order.no-device-warning' | translate }}
    </span>
    }
  </div>

  <div class="os-inst-kv">
    <span class="os-inst-k">{{ 'service-order.gateway-label' | translate }}</span>
    <span class="os-inst-v" [class.os-inst-v--empty]="!installation.details?.gatewayReference">
      {{ installation.details?.gatewayReference || ('service-order.not-informed' | translate) }}
    </span>
  </div>

  @if (installation.details?.lampType) {
  <div class="os-inst-kv">
    <span class="os-inst-k">{{ 'service-order.lamp-label' | translate }}</span>
    <span class="os-inst-v">{{ installation.details?.lampType }}</span>
  </div>
  }
  }
</aside>
